import activityFactory from '@polleverywhere/graphql-models/lib/activityFactory'
import store from '@polleverywhere/redux'
import { slice as profileSlice } from '@polleverywhere/redux/slices/profile'
import ErrorModel from '../models/error'
import fetchActivity from './fetch_activity'
import { ActivityRequiresRegistrationError } from '../states/participant/util/ActivityRequiresRegistrationError'
import { FetchActivityError } from '../states/participant/util/FetchActivityError'
import { UnknownActivityError } from '../states/participant/util/UnknownActivityError'

export default async function constructActivity (type = '', permalink = '', options = { fetch: true }) {
  type = type.replace(/s$/, '')

  const activity = activityFactory({
    type,
    permalink
  }, {
    unstable: !!profileSlice.selectUserFeatures(store.getState())?.graphql
  })

  if (!activity) {
    return new ErrorModel({ code: 404 })
  }

  if (!options.fetch) {
    return activity
  }

  try {
    return fetchActivity(activity)
  } catch (e) {
    if (e instanceof UnknownActivityError) {
      return new ErrorModel({ code: 404 })
    } else if (e instanceof FetchActivityError) {
      return new ErrorModel({ code: 404 })
    } else if (e instanceof ActivityRequiresRegistrationError) {
      return new ErrorModel({ code: 403 })
    } else {
      return new ErrorModel({ code: 500 })
    }
  }
}
